import Link from 'next/link';

import { utilFormatPhoneNumber } from '@/fo/util/format-phone-number';

import { PointFeature } from '../../types';

import { styles } from './Info.styles';

export interface InfoProps {
  points: PointFeature[];
}

export function Info({ points }: InfoProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.content()}>
        {points.map((point, index) => (
          <div
            className={slots.info()}
            key={`point-${index}`}
          >
            <p className={slots.title()}>{point.properties.title}</p>
            <p className={slots.address()}>{point.properties.address}</p>
            <Link
              className={slots.phone()}
              href={`tel:${point.properties.phone}`}
            >
              {utilFormatPhoneNumber(point.properties.phone || '')}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
